var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"radarChart",staticStyle:{"height":"400px","width":"90%","margin-bottom":"100px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }